import { Component, OnInit, ViewChild } from '@angular/core';
import { FirebaseService } from '../../services/firebase.service';
import { Router } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import { NgForm } from "@angular/forms";

@Component({
	selector: 'app-login-page',
	templateUrl: './login-page.component.html',
	styleUrls: ['./login-page.component.less']
})
export class LoginPageComponent implements OnInit {
	email: string;
	password: string;
	isLogin: boolean = false;
	message: string = '';
	status: string = 'Loading application..';
	human: boolean = false;
	emailRegex: RegExp = /^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$/;

	@ViewChild('loginForm') loginForm: NgForm;

	constructor(
		private firebaseService: FirebaseService,
		private router: Router
	) { }

	ngOnInit() {

	}

	ngAfterViewInit() {
		var self = this;
		setTimeout(() => {
			window.dispatchEvent(new Event('data-loaded'));
		}, 500);

		self.message = '';

		this.firebaseService.getAuth().subscribe((user) => {
			if (user) {
				self.firebaseService.userDBLogin(user).subscribe(admin => {
					if (admin.email) {
						self.firebaseService.realTimeListener();
						self.isLogin = true;
						// self.router.navigate(['']);
					}
					else {
						self.firebaseService.userLogout();
						self.message = "You don't have permission to access this page.";
					}
				}, error => {
					self.firebaseService.userLogout();
				});
			}
			else {
				console.log('ini tidak login');
				self.isLogin = false;
				self.status  = '';
			}
		});
	}

	onSignInSubmit() {
		var self = this;
		let user = {
			email: this.email,
			password: this.password
		}

		if(!this.loginForm.valid || !this.emailRegex.test(this.email)) {
			this.message = 'Please enter valid email and password.';
			return;
		}

		if(!this.human) {
			this.message = 'Please verify if you are not robot.';
			return;
		}

		this.status  = 'Logging in, please wait..';
		this.message = '';
		this.human   = false;

		try {
			this.firebaseService.userLogin(user).then(function (result) {
				console.log('login berhasil', result);
				// self.router.navigate(['']);
			}).catch((error) => {
				console.log('login gagal', error);
				this.status = '';
				this.message = error.message;
			});
		} catch (error) {
			this.status = '';
			this.message = error.message;
		}

	}

	resolved(captchaResponse: string) {
		// console.log(`Resolved captcha with response ${captchaResponse}:`);
		this.human = true;
    }
}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/login-page/login-page.component.ts